import DailyInsectCountChart, { ALERT_STYLES as _ALERT_STYLES } from './DailyInsectCountChart';

export const ALERT_STYLES = _ALERT_STYLES;

export default DailyInsectCountChart;
